/**
 *  페이지 이름
 */
export const ACCOUNT_ADMIN_PAGE_NAME = {
  ADMIN_LIST: '관리자 리스트',
  ADMIN_CREATE: '관리자 등록',
  ADMIN_DETAIL: '관리자 상세',
  ADMIN_EDIT: '관리자 편집',
};

/**
 *  관리자 관리권한 선택 리스트
 */
export const ACCOUNT_ADMIN_LEVEL_SELECT_LIST = [
  {
    id: 1,
    name: '1',
  },
  {
    id: 2,
    name: '2',
  },
  {
    id: 3,
    name: '3',
  },
];

/**
 *  관리자 모달 타입
 */
export const ADMIN_DETAIL_MODAL_TYPE = {
  CREATE: 1,
  EDIT: 2,
};

/**
 *  관리자 리스트가 없을 때 보여주는 텍스트
 */
export const ACCOUNT_ADMIN_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 어드민 리스트가 없습니다.';

export const ACCOUNT_ADMIN_TAB_TITLE = {
  ADMIN_INFO: '관리자 기본 정보',
  ADMIN_PERMISSION: '관리자 권한 정보',
};

export const ACCOUNT_ADMIN_TAB_KEY = {
  ADMIN_INFO: 0,
  ADMIN_PERMISSION: 1,
};
